<template>
  <div>
    <el-input v-model="input" :readonly="readonly" :placeholder="placeholderVal"></el-input>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input: "",
      placeholderVal: this.placeholderParam
    };
  },
  props: {
    newValue: {
      type: String,
      default: "",
    },
    readonly:{
      type:Boolean,
      default: false
    },
    placeholderParam:{
      type: String,
      default: ""
    }
  },
  watch: {
    input(val, oldVal) {
      if (val != oldVal) {
        this.$emit("input", this.input);
      }
    },
    newValue: {
      deep: true,
      handler(val) {
        this.input =  val;
      },
    },
  },
  mounted() {

  },
};
</script>
<style scoped>
::v-deep .el-input__inner{
  width: 324px;
  height: 44px !important;
  border-radius: 8px !important;
  background: #F2F2ED;
  border: none;
  box-shadow: -2px -2px 5px #ffffff inset, -2px -2px 5px #ffffff inset,
    4px 5px 5px #E6E6E1 inset, 4px 5px 5px #E6E6E1 inset;
}
</style>
